<template>
	<div class="row justify-content-center">
		<div class="col-11">
			<logo-bar></logo-bar>
			<!-- all user roles -->
			<router-button to="/info"
			               :title="$t('Flaschen info')"
			               theme-color="medium-gray"
			/>

			<!-- user role "manager" -->
			<template v-if="['manager', 'admin'].indexOf(tokenData.aud) !== -1">
				<router-button to="/entered_storage/properties"
				               :title="$t('Zum Inventar hinzufügen')"
				/>
				<p>{{ $t('Wurden die Flaschen abgeholt?') }}</p>

				<button class="btn-primary router-button" @click="moveOutOfStorage">
					{{ $t('Leergut leeren') }}<span v-if="emptyBottlesInStorage.length > 0"
					                                class="batch">{{ emptyBottlesInStorage.length }}</span>
				</button>
			</template>

			<!-- user role "driver" -->
			<template v-if="['driver', 'admin'].indexOf(tokenData.aud) !== -1">
				<router-button to="/at_customer/scanner"
				               :title="$t('Flaschen abgeben')"
				/>
				<router-button to="/from_customer/customer"
				               :title="$t('Flaschen abholen')"
				/>
				<p>{{ $t('Sie haben noch Flaschen in Ihrem Auto?') }}</p>
				<button class="btn-primary router-button" @click="moveBackInStorage">
					{{ $t('Flaschen ausladen') }}<span v-if="emptyBottlesInCar.length > 0"
					                                   class="batch">{{ emptyBottlesInCar.length }}</span>
				</button>
			</template>

			<!--			<button class="btn btn-outline-warning" @click="sendBugReport">-->
			<!--				Bugreport senden-->
			<!--			</button>-->
		</div>
	</div>

</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import RouterButton from "../components/RouterButton";
import LogoBar from "../components/LogoBar";
import allViews from "../mixins/allViews";

export default {
	name: "Home",
	components: {RouterButton, LogoBar},
	mixins: [allViews],
	computed: {
		...mapState({
			tokenData: state => state.Api.authTokenData,
			user: state => state.Api.Users.current,
			bottles: state => state.Api.Bottles.all
		}),
		...mapGetters({
			getLatestActionId: "getLatestActionId"
		}),
		emptyBottlesInStorage() {
			return this.bottles.filter(el => el.bottle_actions
				&& el.bottle_actions[0]
				&& el.bottle_actions[0].action === "back_in_storage")
		},
		emptyBottlesInCar() {
			if (!this.user) {
				return [];
			}

			return this.bottles.filter(el => {
				return el.bottle_actions
					&& el.bottle_actions[0]
					&& el.bottle_actions[0].action === "from_customer"
					&& el.bottle_actions[0].driver_id === this.user.id
			})
		}
	},
	mounted() {
		this.refreshBottles().catch(this.apiErrorHandler);
		this.fetchUserDetails({id: "self"}).catch(this.apiErrorHandler)
	},
	methods: {
		// ...mapActions(['moveBottlesBackInStorage', 'bottlesLeftStorage', 'refreshBottles', 'fetchUserDetails', 'apiRequest']),
		...mapActions({
			backInStorage: "Api/Bottles/back_in_storage",
			leftStorage: "Api/Bottles/left_storage",
			refreshBottles: "Api/Bottles/all",
			fetchUserDetails: "Api/Users/get",
		}),
		async moveBackInStorage() {
			if (this.emptyBottlesInCar.length > 0 && this.user) {

				try {
					await this.refreshBottles();

					let bottles = this.emptyBottlesInCar.map(el => {
						return {
							serial: el.serial,
							parent_id: this.getLatestActionId(el.serial)
						}
					});

					let movedBottles = await this.backInStorage({bottles: bottles});

					if (movedBottles.length === 1) {
						this.cdvAlert(this.$t('1 Flasche erfolgreich zum Leergut gestellt'));
					} else {
						this.cdvAlert([movedBottles.length, this.$t('Flaschen erfolgreich zum Leergut gestellt')].join(' '));
					}

					await this.refreshBottles();

				} catch (e) {
					this.apiErrorHandler(e)
				}

			}
		},
		async moveOutOfStorage() {
			try {
				await this.refreshBottles();

				let bottlesToMove = this.emptyBottlesInStorage.map(el => {
					return {
						serial: el.serial,
						parent_id: el.bottle_actions[0].id
					}
				});

				await this.leftStorage({bottles: bottlesToMove});

				await this.refreshBottles();

				this.cdvAlert(this.$t('Leergut erfolgreich an großhändler übergeben'));

			} catch (error) {
				this.apiErrorHandler(error)
			}
		},

		/**
		 * @deprecated
		 */
		sendBugReport() {
			let headers = {
				'Content-Type': 'application/json',
			};
			let exportState = JSON.parse(JSON.stringify({
				state: this.$store.state,
				getAuthHeader: this.$store.getters.getAuthHeader,
				getSelectedCustomer: this.$store.getters.getSelectedCustomer,
			}));

			this.apiRequest({
				actionPath: '/debug/report.json',
				method: 'POST',
				headers: headers,
				data: {
					state: exportState
				}
			}).then(result => {
				this.cdvAlert("Bugreport was sent")
			}).catch(this.apiErrorHandler)

		}
	}
}
</script>
